import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _noop from 'lodash/noop';
import _debounce from 'lodash/debounce';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import { Mentions as AntdMention } from 'antd';
import { EMPTY_ARRAY, EMPTY_STRING, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import TEnvReader from '@tekion/tekion-base/readers/Env';
import UserApi from '@tekion/tekion-base/services/usersService';
import Request from '@tekion/tekion-base/builders/request';
import UserReader from '@tekion/tekion-base/readers/User';
import FILTER_OPERATORS from '@tekion/tekion-base/constants/filterOperators';
import Avatar from '../../../atoms/Avatar';
import styles from './mentions.module.scss';
var Option = AntdMention.Option;
var ENTER_KEY_CODE = 13;
var Mentions = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Mentions, _React$PureComponent);
  var _super = _createSuper(Mentions);
  function Mentions(props) {
    var _this;
    _classCallCheck(this, Mentions);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onSearch", _debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(searchQuery) {
        var mentions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.setAllowWEnter(false);
              _context.next = 3;
              return _this.searchUserByPersona(searchQuery);
            case 3:
              mentions = _context.sent;
              _this.setMentions(mentions);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 500));
    _defineProperty(_assertThisInitialized(_this), "setAllowWEnter", function (val) {
      return _this.setState({
        allowEnter: val
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setMentions", function (val) {
      return _this.setState({
        mentions: val || EMPTY_ARRAY
      });
    });
    _defineProperty(_assertThisInitialized(_this), "filterMentions", function (users) {
      return _map(users, function (user) {
        return {
          original: user,
          value: (user === null || user === void 0 ? void 0 : user.displayName) || EMPTY_STRING,
          id: user === null || user === void 0 ? void 0 : user.id
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onChange", function (val) {
      var onChange = _this.props.onChange;
      _this.setAllowWEnter(true);
      onChange(val);
    });
    _defineProperty(_assertThisInitialized(_this), "onSelect", function (val) {
      var onSelect = _this.props.onSelect;
      onSelect(val);
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var allowEnter = _this.state.allowEnter;
      var onKeyDown = _this.props.onKeyDown;
      if (allowEnter && event.keyCode === ENTER_KEY_CODE && !event.shiftKey) {
        onKeyDown();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "searchUserByPersona", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(searchQuery) {
        var result, personas, userInfo, reqPayload, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              result = EMPTY_ARRAY;
              personas = _this.props.personas;
              if (!(searchQuery && !_isEmpty(personas))) {
                _context2.next = 9;
                break;
              }
              userInfo = TEnvReader.userInfo();
              reqPayload = new Request().addFilter('homeDealerId', FILTER_OPERATORS.IN, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.dealerId]).setSearchString(searchQuery).setPage(0, 20);
              _context2.next = 7;
              return UserApi.searchUserByPersona({
                personas: personas,
                reqPayload: reqPayload
              });
            case 7:
              response = _context2.sent;
              result = _this.filterMentions(response || EMPTY_ARRAY);
            case 9:
              return _context2.abrupt("return", result);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "renderMentions", function () {
      var mentions = _this.state.mentions;
      return _map(mentions, function (item, index) {
        var value = item.value,
          original = item.original;
        var displayName = UserReader.displayName(original);
        var profilePicture = UserReader.profileImgUrl(original);
        return /*#__PURE__*/React.createElement(Option, {
          key: index,
          value: value,
          original: original
        }, /*#__PURE__*/React.createElement(Avatar, {
          src: profilePicture,
          name: displayName,
          displayName: !!displayName
        }));
      });
    });
    _this.state = {
      allowEnter: true,
      mentions: EMPTY_ARRAY
    };
    return _this;
  }
  _createClass(Mentions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        defaultValue = _this$props.defaultValue,
        disabled = _this$props.disabled,
        placeholder = _this$props.placeholder,
        prefix = _this$props.prefix,
        value = _this$props.value;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.container, className),
        role: "presentation",
        onKeyDown: this.onKeyDown
      }, /*#__PURE__*/React.createElement(AntdMention, {
        className: cx(styles.container, className),
        style: style,
        defaultValue: defaultValue,
        disabled: disabled,
        placeholder: placeholder,
        prefix: prefix,
        onChange: this.onChange,
        onSearch: this.onSearch,
        onSelect: this.onSelect,
        value: value
      }, this.renderMentions()));
    }
  }]);
  return Mentions;
}(React.PureComponent);
_defineProperty(Mentions, "propTypes", {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onKeyDown: PropTypes.func,
  prefix: PropTypes.array,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  defaultValue: PropTypes.string,
  personas: PropTypes.array,
  className: PropTypes.string,
  value: PropTypes.string
});
_defineProperty(Mentions, "defaultProps", {
  disabled: false,
  onChange: _noop,
  onSelect: _noop,
  onKeyDown: _noop,
  placeholder: 'Add Note',
  style: EMPTY_OBJECT,
  defaultValue: EMPTY_STRING,
  prefix: ['@'],
  personas: EMPTY_ARRAY,
  className: EMPTY_STRING,
  value: EMPTY_STRING
});
export default Mentions;